module.exports = __webpack_public_path__ + "img/dashboard.8297c79a.svg";